import React, { createContext, useContext } from 'react';

export const AuthContext = createContext({
  isAuthenticated: false,
  loading: true,
  username: null,
  user: null
});

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext deve essere usato dentro AuthGuard');
  }
  return context;
};
